import { useDynamicConfig, useExperiment } from '@statsig/react-bindings';

import BFCM from './_heros/BFCM';
import BoxingDayHero from './_heros/BoxingDayHero';
import DexcomHero from './_heros/DexcomHero';
import GiftingHero from './_heros/GiftingHero';
import GiveUsTheFingerHero from './_heros/GiveUsTheFingerHero';
import NewYearHealthHero from './_heros/NewYearHealthHero';
import NewYearLongevityHero from './_heros/NewYearLongevityHero';
import OR4CeramicHero from './_heros/OR4CeramicHero';
import OR4Hero from './_heros/OR4Hero';
import PrimeHero from './_heros/PrimeHero';
import SinglesDay from './_heros/SinglesDay';
import WinterSaleHero from './_heros/WinterSaleHero';

const heroLookup: Record<string, () => React.JSX.Element> = {
  BFCM,
  BoxingDayHero,
  DexcomHero,
  GiftingHero,
  GiveUsTheFingerHero,
  OR4CeramicHero,
  OR4Hero,
  PrimeHero,
  SinglesDay,
  WinterSaleHero,
  NewYearHealthHero,
  NewYearLongevityHero,
};

type HeroType =
  | 'BFCM'
  | 'BoxingDayHero'
  | 'DexcomHero'
  | 'GiftingHero'
  | 'GiveUsTheFingerHero'
  | 'OR4CeramicHero'
  | 'OR4Hero'
  | 'PrimeHero'
  | 'SinglesDay'
  | 'WinterSaleHero'
  | 'NewYearHealthHero'
  | 'NewYearLongevityHero';

// If statsig misbehaves we will fallback to this
const FallbackHero = OR4Hero;

const HomeHeroGate = () => {
  const heroExperimentVersion = useExperiment('new_year_2025_hp_heros').get(
    'HeroVersion',
  ) as string | null;

  const configHero = useDynamicConfig('home_hero').get(
    'hero',
    'OR4Hero',
  ) as HeroType;

  const Hero =
    (heroExperimentVersion && heroLookup[heroExperimentVersion]) ??
    heroLookup[configHero];

  return Hero ? <Hero /> : <FallbackHero />;
};

export default HomeHeroGate;
